import getNormalizedEnv from './normalize-env';

export default function getCompanyCookieName(env: string): string {
  return `skylab_current_company_${getNormalizedEnv(env)}`;
}
